export default __webpack_public_path__ + "static/laveLingeFaceDesktop-fd3bc34968b75c07364b32ff317bc500.png";